import React from 'react'

import {Preloader} from '@retracedgmbh/ui-components-lib'

export const LoadComponent = () => {
  return <Preloader className="tw:mt-12" />
}

const LazyLoader = () => (
  <div className="container tw:text-center tw:mt-24">
    <div className="columns is-centered">
      <div className="column is-6">
        <h1 className="title is-4">Just take another sip...</h1>
        <span className="icon is-large">
          <i className="fa-solid fa-3x fa-mug-hot" />
        </span>
        <p className="tw:mt-4">...we are generating the requested page!</p>
        <progress className="progress is-info is-small tw:mt-4" />
      </div>
    </div>
  </div>
)

export default LazyLoader
